export const visit = (vm, at) => {
at({ "en": { "pricing-pages-ui": { "hsoc": { "merchCards": { "horizontalFree": { "title": "Free", "description": "Start generating and emailing new leads, and measuring your success \u2014 for free. Free for up to 2 users. No credit card required." } } } } } });
};